/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Link, useNavigate, useNavigation } from 'react-router-dom';

import Swal from 'sweetalert2';

import {
  Grid2,
  Button as ButtonMaterial,
  Typography,
  Dialog,
  DialogTitle,
  Box,
  IconButton,
  DialogContent,
  CircularProgress,
  DialogActions,
  SpeedDial,
  SpeedDialAction,
} from '@mui/material';

import { GroupCard } from '../index';
import { showGroups, deleteGroup } from 'js/actions/groupActions';

import { getConsumesLastMonth } from 'js/actions/preInvoiceGroupAction';
import { makeStyles } from '@mui/styles';
import styles from './styles';
import { useIntl } from 'react-intl';
import { Add, Close, DeviceHub, Settings } from '@mui/icons-material';
import FromStrepper from './FromStrepper';
import {
  getSnapShot,
  postSnapShot,
  updateSnapShop,
} from 'js/actions/userActions';
import { isAllowed } from 'helpers';
const useStyles = makeStyles(styles);

export default function GridGroup(props) {
  const intl = useIntl();
  const { meter } = props;
  const navigation = useNavigate();
  const dispatch = useDispatch();
  let groups = useSelector((state) => state.groups.groups);
  let groupsStatus = useSelector((state) => state.groups.loading);
  const user = useSelector((state) => state.user.user);
  const corpAdmin = useSelector((state) => state.user.corporative);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const corpUser = user.corporative;
  const corporativeId =
    corpUser === undefined || corpUser === null ? corpAdmin.id : corpUser.id;
  let groupsState = useSelector((state) => state.groups);
  let isLoading = groupsStatus;
  const [snapShopView, setSnapShopView] = useState(false);
  const [formData, setFormData] = useState({
    resource_id: '',
    type: 'GRUPO',
    frecuency_config: {
      periods: [],
      days: [],
    },
    contacts: [],
  });
  const { snapShot } = useSelector((state) => state.user);

  useEffect(() => {
    if (selectedGroup) {
      dispatch(getSnapShot(selectedGroup.id, 'GRUPO'));
    }
  }, [selectedGroup]);

  useEffect(() => {
    if (snapShot && snapShot.length > 0) {
      setFormData(snapShot[0]);
    }
  }, [snapShot]);

  const year = new Date().getFullYear();
  const getLastMonth = () => {
    let month = new Date().getMonth() + 1;

    return month - 1;
  };

  const handleSnapShot = () => {
    if (snapShot && snapShot.length > 0) {
      dispatch(updateSnapShop(formData)).then(() => {
        setSnapShopView(false);
      });
    } else {
      dispatch(postSnapShot(formData)).then(() => {
        setSnapShopView(false);
      });
    }
  };

  useEffect(() => {
    dispatch(showGroups(meter.id));
  }, []);

  const handleNew = () => {
    navigation(`/newGroup/${corporativeId}/${meter.id}`, { state: meter });
  };

  const deleteGroupData = (groupId, meter) => {
    Swal.fire({
      title: `${intl.formatMessage({ id: 'app.corporate.grid.btnDelete.title' })} `,
      text: `${intl.formatMessage({ id: 'app.corporate.grid.btnDelete.text' })} ${groupId.name}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: intl.formatMessage({
        id: 'app.corporate.grid.btnDelete.confirmation',
      }),
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: intl.formatMessage({
            id: 'app.corporate.grid.btnDelete.titleConfirmation',
          }),
          text: intl.formatMessage({
            id: 'app.corporate.grid.btnDelete.textConfirmation',
          }),
          icon: 'success',
        });
        dispatch(deleteGroup(groupId.id, meter.id));
      }
    });
  };

  const getConsumesLastMonthData = (groupId, year, month) => {
    dispatch(getConsumesLastMonth(groupId, year, month));
  };

  const [showEditButton, setShowEditButton] = useState(false);
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const [showInvoiceButton, setShowInvoiceButton] = useState(false);

  const getEditButton = (group) => {
    if (showEditButton == false) {
      return <div />;
    } else {
      return (
        <Link
          to={{
            pathname: `/updateGroup/${group.id}`,
            state: { group: group },
          }}
        >
          <ButtonMaterial color="secondary" variant="outlined">
            {intl.formatMessage({ id: 'app.groupsCards.editGroupBtn' })}
          </ButtonMaterial>
        </Link>
      );
    }
  };

  const getDeleteButton = (groupId, meter) => {
    if (showDeleteButton == false) {
      return <div />;
    } else {
      return (
        <ButtonMaterial
          onClick={() => deleteGroupData(groupId, meter)}
          style={{ border: '1px solid #D64539', color: '#D64539' }}
          variant="outlined"
        >
          {intl.formatMessage({ id: 'app.groupsCards.deleteGroupBtn' })}
        </ButtonMaterial>
      );
    }
  };

  const getInvoiceButton = (group) => {
    if (showInvoiceButton == false) {
      return <div />;
    } else {
      return (
        <Link
          to={{
            pathname: `/preinvoicegroup/${group.id}`,
            state: { group: group },
          }}
        >
          <ButtonMaterial
            color="secondary"
            onClick={() =>
              getConsumesLastMonthData(group.id, year, getLastMonth())
            }
            variant="outlined"
          >
            {intl.formatMessage({ id: 'app.groupsCards.preInvBtn' })}
          </ButtonMaterial>
        </Link>
      );
    }
  };

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '50px',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          {groups.length > 0 ? (
            <Grid2 container={true} spacing={2}>
              {groups
                .sort((a, b) =>
                  a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
                )
                .map((group) => (
                  <Grid2 size={{ xs: 12, md: 6, lg: 4 }} key={group.id}>
                    <GroupCard
                      deleteButton={showDeleteButton}
                      editButton={showEditButton}
                      group={group}
                      item
                      key={group.id}
                      meter={meter}
                      setSelectedGroup={setSelectedGroup}
                      setShowDetails={setShowDetails}
                      setSnapShopView={setSnapShopView}
                      snapShopView={snapShopView}
                    />

                    <div>
                      {getEditButton(group)}
                      {getDeleteButton(group, group.meter_id)}
                      {getInvoiceButton(group)}
                    </div>
                  </Grid2>
                ))}
            </Grid2>
          ) : (
            <Grid2 container={true} spacing={4}>
              <Grid2 size={12}>
                <Typography style={{ textAlign: 'center' }} variant="h2">
                  {intl.formatMessage({
                    id: 'app.groupsCards.noGroupsMsg',
                  })}{' '}
                </Typography>
              </Grid2>
              <Grid2 size={12}>
                <Link>
                  <ButtonMaterial
                    color="secondary"
                    style={{ margin: '0 auto', display: 'block' }}
                    variant="outlined"
                  >
                    {intl.formatMessage({
                      id: 'app.groupsCards.createGroupBtn',
                    })}
                  </ButtonMaterial>
                </Link>
              </Grid2>
            </Grid2>
          )}
          <Dialog
            aria-labelledby="customized-dialog-title"
            fullWidth
            maxWidth={'sm'}
            onClose={() => setShowDetails(false)}
            open={showDetails}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={() => setShowDetails(false)}
            >
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="h6">
                  {selectedGroup ? selectedGroup.name : ''}
                </Typography>
                <IconButton
                  aria-label="close"
                  onClick={() => setShowDetails(false)}
                  size="small"
                >
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent dividers style={{ marginBottom: '3rem' }}>
              {selectedGroup ? (
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    style={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography style={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.groupsCards.editGroup.description',
                      })}
                    </Typography>
                    {selectedGroup.description}
                  </Typography>
                  <Typography
                    style={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography style={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.groupsCards.editGroup.monitChargeLbl',
                      })}
                    </Typography>
                    {selectedGroup.monitoring_fee}
                  </Typography>
                  <Typography
                    style={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography style={{ fontWeight: 500 }}>
                      {intl.formatMessage({
                        id: 'app.groupsCards.editGroup.fixedChargeLbl',
                      })}
                    </Typography>
                    {selectedGroup.flat_fee}
                  </Typography>
                  <Typography
                    style={{ fontWeight: 400, textAlign: 'center' }}
                    variant="h6"
                  >
                    <Typography style={{ fontWeight: 500 }}>
                      {selectedGroup.is_custom_tariff !== 0
                        ? intl.formatMessage({
                            id: 'app.groupsCards.editGroup.rateTypeLbl',
                          })
                        : intl.formatMessage({
                            id: 'app.groupsCards.editGroup.customRateLbl',
                          })}
                    </Typography>
                    {selectedGroup.is_custom_tariff !== 0
                      ? selectedGroup.rate_type
                      : selectedGroup.custom_tariff}
                  </Typography>
                </Box>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '50vh',
                  }}
                >
                  <CircularProgress />
                </div>
              )}
            </DialogContent>
          </Dialog>
        </>
      )}
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth
        maxWidth={'lg'}
        onClose={() => {
          setSnapShopView(false);
        }}
        open={snapShopView}
        style={{ zIndex: 1050 }}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setSnapShopView(false)}
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Typography gutterBottom variant="h5">
                Configuración de Snapshots{' '}
                {selectedGroup ? `- ${selectedGroup.name}` : ''}
              </Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={() => setSnapShopView(false)}
              size="small"
            >
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <FromStrepper
            formData={formData}
            selectedCharge={selectedGroup}
            setFormData={setFormData}
          />
          {/* {renderDias()} */}
        </DialogContent>
        <DialogActions>
          {snapShot && snapShot.length > 0 ? (
            <ButtonMaterial
              color="secondary"
              disabled={
                !formData.resource_id ||
                !formData.frecuency_config.periods.length ||
                !formData.frecuency_config.days.length ||
                !formData.contacts.length
              }
              onClick={handleSnapShot}
              variant="contained"
            >
              Editar
            </ButtonMaterial>
          ) : (
            <ButtonMaterial
              color="secondary"
              disabled={
                !formData.resource_id ||
                !formData.frecuency_config.periods.length ||
                !formData.frecuency_config.days.length ||
                !formData.contacts.length
              }
              onClick={handleSnapShot}
              variant="contained"
            >
              Guardar
            </ButtonMaterial>
          )}
          <ButtonMaterial
            color="secondary"
            onClick={() => setSnapShopView(false)}
            variant="outlined"
          >
            Cerrar
          </ButtonMaterial>
        </DialogActions>
      </Dialog>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          '& .MuiFab-primary': {
            width: 80, // Ajusta el tamaño del botón principal
            height: 80,
            backgroundColor: '#A53693', // Cambia el color de fondo
            '&:hover': {
              backgroundColor: '#6A1A5F',
            },
          },
        }}
        icon={
          <Settings
            sx={{
              width: 40,
              height: 40,
              transform: 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'rotate(180deg)',
                backgroundColor: '#6A1A5F',
              },
            }}
          />
        }
      >
        <SpeedDialAction
          key={1}
          icon={<DeviceHub />}
          href={`/hardwareConfiguration/${meter.id}`}
          tooltipTitle={intl.formatMessage({
            id: 'app.groupsCards.confHardwarepBtn.toolTip',
          })}
          sx={{
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em',
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          }}
        />
        {isAllowed(user.permissions, ['group_create']) && (
          <SpeedDialAction
            key={2}
            tooltipTitle={intl.formatMessage({
              id: 'app.groupsCards.addGroupBtn.toolTip',
            })}
            icon={<Add />}
            onClick={handleNew}
            sx={{
              backgroundColor: '#00AFEF',
              color: '#fff',
              width: '60px',
              height: '60px',
              fontSize: '1.5em',
              '&:hover': {
                backgroundColor: 'rgb(0, 146, 199)',
              },
            }}
          />
        )}
      </SpeedDial>
    </div>
  );
}
